/**
 * Resolve a displayable event number from common API field variants.
 * @param {object|null|undefined} ev
 * @returns {string}
 */
export function pickEventDisplayNumber(ev) {
  if (!ev || typeof ev !== "object") return "";
  const raw =
    ev.eventnumber ??
    ev.eventNumber ??
    ev.event_number ??
    ev.eventno ??
    ev.eventNo;
  if (raw == null || raw === "") return "";
  return String(raw).trim();
}
